/**
 * 广告 接口的统一出口
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/';

const media = {
    // 列表
    list(params) {
        return axios.get(api + 'media/medialist', {params: params});
    },
    breadcrumblist(params) {
        return axios.get(api + 'media/breadcrumblist', {params: params});
    },
    // 添加
    create(params) {
        return axios.post(api + 'media/createmedia', qs.stringify(params))
    },
    // 修改
    edit(params) {
        return axios.post(api + 'media/editmedia', qs.stringify(params))
    },
    // 单个查看
    detail(params) {
        return axios.get(api + 'media/mediadetail', {params: params})
    },
    // 删除
    remove(params) {
        return axios.post(api + 'media/removemedia', qs.stringify(params))
    },
    // 移动
    move(params) {
        return axios.post(api + 'media/movemedia', qs.stringify(params))
    },
    sectionlist(params) {
        return axios.get(api + 'media/sectionlist', {params: params})
    },
    sectionshared(params) {
        return axios.post(api + 'media/sectionshared', qs.stringify(params))
    },
}


// 导出接口
export default media